(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function formatMoney(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) || 'R {{amount}}';
    const value = (cents / 100).toFixed(2);
    const withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  /* Drawers */
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    const f = d.querySelector('[data-drawer-close]');
    f && f.focus();
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.drawerOpen); if (opener.dataset.drawerOpen === 'CartDrawer') refreshCart(); }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
    const st = e.target.closest('[data-search-toggle]');
    if (st) { e.preventDefault(); const bar = $('#HeaderSearch'); bar.classList.toggle('is-open'); if (bar.classList.contains('is-open')) $('input', bar).focus(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer); });

  /* Cart */
  async function refreshCart() {
    const res = await fetch(window.theme.routes.root.replace(/\/$/, '') + '/?sections=cart-drawer-content');
    if (!res.ok) return;
    const data = await res.json();
    const html = data['cart-drawer-content'];
    const wrap = document.createElement('div');
    wrap.innerHTML = html;
    const next = wrap.querySelector('#CartDrawerInner');
    const cur = $('#CartDrawerInner');
    if (next && cur) cur.replaceWith(next);
    const count = next ? next.dataset.count : '0';
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.dataset.count = count; });
  }
  window.DropDew = { refreshCart, formatMoney, openDrawer };

  async function addToCart(form, btn) {
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.dataset.adding || 'Adding…'; }
    try {
      const res = await fetch(window.theme.routes.cart_add + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Could not add to bag');
      await refreshCart();
      openDrawer('CartDrawer');
    } catch (err) {
      const msg = form.querySelector('[data-form-error]');
      if (msg) { msg.textContent = err.message; msg.hidden = false; } else alert(err.message);
    } finally {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
    }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type=submit]'));
  });

  async function changeLine(line, quantity) {
    const cur = $('#CartDrawerInner'); if (cur) cur.style.opacity = '.5';
    await fetch(window.theme.routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity }),
    });
    if (document.body.classList.contains('template-cart')) { location.reload(); return; }
    await refreshCart();
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-line-qty]');
    if (q) { e.preventDefault(); changeLine(Number(q.dataset.line), Math.max(0, Number(q.dataset.lineQty))); }
    const step = e.target.closest('[data-qty-step]');
    if (step) { e.preventDefault(); const input = step.parentElement.querySelector('input'); const v = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(step.dataset.qtyStep)); input.value = v; input.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  /* Product page variant picker */
  $$('[data-product-form]').forEach((root) => {
    const dataEl = root.querySelector('[data-variants-json]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = root.querySelector('input[name="id"]');
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare]');
    const addBtn = root.querySelector('[data-add-btn]');
    const avail = root.querySelector('[data-availability]');
    const optionSets = $$('fieldset[data-option-index]', root);

    function current() {
      const chosen = optionSets.map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
      return variants.find((v) => v.options.every((o, i) => o === chosen[i]));
    }
    function update() {
      const v = current();
      if (!v) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailable; return; }
      idInput.value = v.id;
      priceEl.textContent = formatMoney(v.price);
      if (compareEl) { if (v.compare_at_price > v.price) { compareEl.textContent = formatMoney(v.compare_at_price); compareEl.hidden = false; } else compareEl.hidden = true; }
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addBtn.dataset.add : addBtn.dataset.soldout;
      if (avail) { avail.querySelector('.dot').classList.toggle('out', !v.available); avail.querySelector('span:last-child').textContent = v.available ? avail.dataset.in : avail.dataset.out; }
      if (v.featured_media) {
        const t = document.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        t && t.click();
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      root.dispatchEvent(new CustomEvent('variant:change', { detail: v }));
    }
    optionSets.forEach((fs) => fs.addEventListener('change', update));
  });

  /* Gallery */
  $$('[data-gallery]').forEach((g) => {
    const main = g.querySelector('[data-gallery-main] img');
    $$('[data-gallery-thumb]', g).forEach((b) => b.addEventListener('click', () => {
      $$('[data-gallery-thumb]', g).forEach((x) => x.classList.remove('is-active'));
      b.classList.add('is-active');
      main.src = b.dataset.src; main.srcset = b.dataset.srcset || ''; main.alt = b.dataset.alt || '';
    }));
  });

  /* Collection sort & filters */
  $$('[data-sort-select]').forEach((s) => s.addEventListener('change', () => {
    const url = new URL(location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page'); location.href = url;
  }));
  $$('form[data-filter-form]').forEach((f) => f.addEventListener('change', () => f.requestSubmit ? f.requestSubmit() : f.submit()));

  /* Rise-on-scroll */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('rise'); en.target.style.opacity = ''; io.unobserve(en.target); } }), { threshold: 0.12 });
    $$('[data-reveal]').forEach((el) => { el.style.opacity = '0'; io.observe(el); });
  }
})();
